<icc-list
    [items]="muntinTypes"
    [itemTemplate]="'itemImgTitle'"
    itemImgHeight="medium"
    (select)="selectMuntinType($event)"
    [selected]="(muntinsType$ | async)?.id"
></icc-list>

